import React from 'react'
import { useNavigate } from 'react-router-dom'
import GlobalFooter from './GlobalFooter'

function PaymentFailed() {
    const navigate = useNavigate()
    const record = JSON.parse(localStorage.getItem("auth"))
    const handleClick =()=>{
        navigate('/pages/account-info')
    }
    const handleClose = ()=>{
        navigate('/pages/global-payment')
      }
  return (
    <div className='global_layout'>
        {/* {
                 record?.avatar ?
                 <div className='img_container'>
                     <img className='img_glob' src={record?.avatar} alt=''/>
                 </div>:
                <div className='glob_avater custom_avater'>
                    <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0, 1)}</p>
                </div>
        } */}
    
        <div className='global_container'>
            <div className='top_bar'>
                {/* <img src='/images/global/arrow-left.svg' alt=''/> */}
                <img src='/images/global/close.svg' alt='' style={{marginLeft:"auto"}} onClick={handleClose}/>
            </div>

            <div className='global_content'>
                <img style={{width:"60px",height:"60px"}} src='/images/global/sickFace.gif' alt='' />
                <p className='glob_title'>Payment Failed</p>
                <p className='glob_desc'>Your transaction was not successful.</p>
                
               {/* <button className='btn' style={{marginTop:"18px",background:"#228985",borderRadius:"10000px"}} onClick={handleClick}>Try again</button> */}

            </div>
        </div>
        {
            !record?.total_whitelabelling &&
            <GlobalFooter />
        }
    </div>
  )
}

export default PaymentFailed